<template>
  <div class="videojs-box">
    <video
      ref="video"
      id="my-player"
      class="video-js vjs-big-play-centered"
      preload="auto"
      :poster="'//image.micoworld.net/' + profile.cover"
      playsinline
      data-setup='{}'>
      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that
        <a href="https://videojs.com/html5-video-support/" target="_blank">
          supports HTML5 video
        </a>
      </p>
    </video>
  </div>
</template>
<script>
  import videojs from 'videojs'
  export default {
    props: {
      profile: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        player: null,
      }
    },
    methods: {
      async play() {
        return this.player.play()
      }
    },
    async mounted() {
//      const videoEle = this.$refs.video
      const options = {
        controls: false,
        notSupportedMessage: `Your device don't supported yet`,
        sources: [{
          src: this.profile.h5_url,
          type: 'application/x-mpegURL'
        }]
      };

      this.player = videojs('my-player', options, async() => {
        videojs.log('Your player is ready!');

        // In this context, `this` is the player that was created by Video.js.
        try {
          await this.play();
        } catch(error) {
          $('.video-js .vjs-big-play-button').show()
        }
        this.player.on('play', () => {
          $('.video-js .vjs-big-play-button').css('display', '')
        })
        // How about an event listener?
        this.player.on('ended', function() {
          this.$emit('end')
          videojs.log('Awww...over so soon?!');
        });
      });
    }
  }
</script>
<style lang="less">
@import "../css/videojs.less";
</style>
